<div class="user-settings-component-container">
  <div class="user-settings__order-blotter__temperature__container">
    <p-dataTable
      #dataTable
      *ngIf="ready"
      [value]="ccyPairObjRecords"
      [rows]="PAIR_TEMPERATURE_ROW_COUNT"
      [lazy]="true"
      [paginator]="true"
      [totalRecords]="totalRecords"
      [pageLinks]="0"
      (onLazyLoad)="loadPairsLazy($event)"
      [(first)]="first"
    >
      <p-column
        field="ccyPairIdentifier"
        header="Instrument"
        styleClass="user-settings__order-blotter__temperature__columnStyle"
        [style]="{'width':'15%'}"
        [ngClass]="true ? 'not-edited' : null"
      >
        <ng-template let-col let-data="rowData" pTemplate="body">
          <span [ngClass]="!data.isEdited ? 'not-edited' : 'is-edited'">{{data[col.field]}}</span>
        </ng-template>
      </p-column>
      <p-column
        header="Warm"
        styleClass="user-settings__order-blotter__temperature__columnStyle"
        [style]="{'width':'15%'}"
      >
        <ng-template let-col let-data="rowData" pTemplate="body">
          <bfx-temperature-spinner
            fxFlex="1 1 100%"
            size="sm"
            [(ngModel)]="data.warmSetting"
            [minPrecision]="data.precision"
            [maxPrecision]="data.precision"
            [min]="data.minValue"
            [max]="data.maxValue"
            (ngModelChange)="rowEditedTemp($event, data)"
            [ngClass]="!data.isEdited ? 'not-edited' : 'is-edited'"
            [showValidationBar]="false"
            fieldSuffix=""
            [mandatory]="false"
          >
          </bfx-temperature-spinner>
        </ng-template>
      </p-column>
      <p-column
        header="Hot"
        styleClass="user-settings__order-blotter__temperature__columnStyle"
        [style]="{'width':'15%'}"
      >
        <ng-template let-col let-data="rowData" pTemplate="body">
          <bfx-temperature-spinner
            size="sm"
            fxFlex="1 1 100%"
            [(ngModel)]="data.hotSetting"
            [minPrecision]="data.precision"
            [maxPrecision]="data.precision"
            [min]="data.minValue"
            [max]="data.maxValue"
            (ngModelChange)="rowEditedTemp($event, data)"
            [ngClass]="!data.isEdited ? 'not-edited' : 'is-edited'"
            [showValidationBar]="false"
            fieldSuffix=""
            [mandatory]="true"
          >
          </bfx-temperature-spinner>
        </ng-template>
      </p-column>
      <p-column
        header="Type"
        styleClass="user-settings__order-blotter__temperature__columnStyle"
        [style]="{'width':'15%'}"
      >
        <ng-template let-col let-data="rowData" pTemplate="body">
          <bfx-autoComplete
            size="sm"
            appendTo="body"
            [(ngModel)]="data.typeSetting"
            [suggestions]="typeSuggestions"
            [autoHighlight]="true"
            (completeMethod)="searchType($event)"
            [dropdown]="true"
            [delay]="5"
            field="label"
            dataKey="value"
            [minLength]="0"
            [maxlength]="4"
            (ngModelChange)="rowEditedType($event, data)"
            [ngClass]="!data.isEdited ? 'not-edited' : 'is-edited'"
          >
          </bfx-autoComplete>
        </ng-template>
      </p-column>
      <p-column
        header=""
        [filter]="true"
        styleClass="user-settings__order-blotter__temperature__columnStyle"
        [style]="{'width':'40%'}"
      >
        <ng-template pTemplate="filter" let-col>
          <div class="temperature-filter-header">
            <bfx-text-input
              class="search-field"
              bfxautofocus
              #reasonInput
              type="search"
              *ngIf="showSearch"
              [(ngModel)]="filterValue"
              (ngModelChange)="onChangeSearchValue($event)"
              [size]="'sm'"
              [maxLength]="100"
            ></bfx-text-input>
            <bfx-icon-button
              size="sm"
              iconClass="icon-search"
              (action)="toggleSearch()"
              title="Search"
            ></bfx-icon-button>
          </div>
        </ng-template>
        <ng-template let-col let-data="rowData" let-rowIndex="rowIndex" pTemplate="body">
          <div class="temperature-filter-col">
            <button
              *ngIf="!data.isDefault"
              class="bfx-button-secondary-moderate"
              (click)="revertToDefault($event, data)"
            >
              Reset to Default
            </button>
          </div>
        </ng-template>
      </p-column>
    </p-dataTable>
  </div>
</div>
